import { appConfig } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const swordsOfBloodQuestsList: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow on Immutable Play",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "e2ac7c08-890d-4062-a59e-8e5737e913ea-wishlist-added",
    ruleId: "e2ac7c08-890d-4062-a59e-8e5737e913ea-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch Game Trailer",
    caption: "Learn about what's coming up",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/swords-of-blood/SwordsOfBloodTrailer.mp4`,
    videoMimeType: "video/mp4",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "e2ac7c08-890d-4062-a59e-8e5737e913ea-trailer-watched",
    ruleId: "e2ac7c08-890d-4062-a59e-8e5737e913ea-trailer",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow @SwordsofBlood_ on X",
    caption: "Stay updated with the latest news",
    linkUrl: "https://x.com/SwordsofBlood_",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "e2ac7c08-890d-4062-a59e-8e5737e913ea-twitter-followed",
    ruleId: "e2ac7c08-890d-4062-a59e-8e5737e913ea-twitter",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord channel",
    caption: "Join our massively growing community",
    linkUrl: "https://discord.com/invite/swordsofblood2025",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "e2ac7c08-890d-4062-a59e-8e5737e913ea-discord-joined",
    ruleId: "e2ac7c08-890d-4062-a59e-8e5737e913ea-discord",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Follow on Instagram",
    caption: "Stay connected on social media",
    linkUrl: "https://www.instagram.com/swordsofblood_/",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "e2ac7c08-890d-4062-a59e-8e5737e913ea-instagram-followed",
    ruleId: "e2ac7c08-890d-4062-a59e-8e5737e913ea-instagram",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Sign up for Beta",
    caption: "Be among the first to play",
    linkUrl:
      "https://docs.google.com/forms/d/e/1FAIpQLSdJP6QPKNItVuyuiT9dQ2BGrgc7HRhQ3Tj4DElZPX9y_UBeXQ/viewform",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "e2ac7c08-890d-4062-a59e-8e5737e913ea-beta-signup",
    ruleId: "e2ac7c08-890d-4062-a59e-8e5737e913ea-beta",
  },
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "e2ac7c08-890d-4062-a59e-8e5737e913ea-onboarding-completed",
    ruleId: "e2ac7c08-890d-4062-a59e-8e5737e913ea-onboarding",
  },
];

export const swordsOfBloodQuests: QuestGroup[] = [
  {
    key: "level-0",
    header: {
      image: "",
      description: "",
      title: "Learn and connect",
    },
    nextQuest: {
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    totalGemsGranted: 40,
    quests: swordsOfBloodQuestsList,
  },
];
